// لیست با پیش و پس غیر مهم
export const notImportantPreFlags = [
  { id: 1723, title: "من کافی ( پذیرش خود)" },
  { id: 1280, title: "بعد پنهان زندگی" },
  { id: 1278, title: "تاهل یا تجرد" },
  { id: 1274, title: "اعتماد به نفس" },
  { id: 1272, title: "افزایش عزت نفس" },
  { id: 1273, title: "مدیریت هیجانات" },
  { id: 1193, title: "استقلال" },
  { id: 1175, title: "مدیریت رفتارهای عادت گونه" },
];
